module.exports = __webpack_public_path__ + "img/Semper_Fi_Cycle@1x.70485a14.webp";